var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.651,
    height: 17.109,
    viewBox: "0 0 18.651 17.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1396",
    "data-name": "Groupe 1396",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_799",
    "data-name": "Groupe 799",
    transform: "translate(3.6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 4.725,
    cy: 4.288,
    rx: 4.725,
    ry: 4.288,
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_634",
    "data-name": "Trac\\xE9 634",
    d: "M2855.75,3851.568h0c0-3.608,3.224-6.533,7.2-6.533h2.251c3.976,0,7.2,2.925,7.2,6.533h0",
    transform: "translate(-2855.75 -3836.46)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.14d2f3a24ce9673c8dbe5e6f47f44aaf.svg";
export { ForwardRef as ReactComponent };